import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import BackButton from "../../../components/custom/BackButton";
import {
    HeaderContainer,
} from "./styles";
import VirtualTable from "../../../components/custom/VirtualTable";
import { formatDatetime, notify } from "../../../utils";
import { UnitDetail } from "./types";
import moment from "moment";
import useSerials, { Serial } from "./useSerials";
import { create } from "zustand";
import ActionIcon from "../../../components/custom/ActionIcon";
import styled from "styled-components";

export const useSerialsModalDataStore = create<{
    modal: boolean;
    setModal: (modal: boolean) => void;
    id: number | string;
    setId: (id: number | string) => void;
    title: string;
    setTitle: (value: string) => void;
    viewSerials: (id: number | string, title: string, type: 'activity' | 'units') => void;
    type: 'activity' | 'units';
    refreshIndex: number;
    refreshSerials: () => void;
}>((set, get) => ({
    modal: false,
    setModal: (modal: boolean) => set({ modal }),
    id: undefined,
    setId: (id: number | string) => set({ id }),
    title: undefined,
    setTitle: (title: string) => set({ title }),
    viewSerials: (id: number | string, title: string, type: 'activity' | 'units') => {
        set({ id });
        set({ title });
        set({ type });
        set({
            modal: true
        });
    },
    type: 'activity',
    refreshIndex: 0,
    refreshSerials: () => {
        const { refreshIndex } = get();
        set({
            refreshIndex: refreshIndex + 1
        });
    }
}));

interface UnitDetailModalProps {
    handleAddQty: (id: string) => void;
    loadUnit: (serial: string) => Promise<void>;
}

export default function SerialsModal({
    loadUnit,
    handleAddQty
}: UnitDetailModalProps) {

    const id = useSerialsModalDataStore(s => s.id);
    const title = useSerialsModalDataStore(s => s.title);
    const modal = useSerialsModalDataStore(s => s.modal);
    const setModal = useSerialsModalDataStore(s => s.setModal);
    const type = useSerialsModalDataStore(s => s.type);
    const refreshIndex = useSerialsModalDataStore(s => s.refreshIndex);

    const toggle = () => setModal(!modal);

    const serials = useSerials(id, type, refreshIndex);

    if (!serials) {
        notify('No serials found!', 'error');
        setModal(false);
        return null;
    }

    return (
        <CustomModal isOpen={modal} toggle={toggle}>
            <ModalHeader className={"d-flex"}>
                <HeaderContainer>
                        <FlexContainer>
                            <BackButton onClick={toggle} />
                            <h4 className={"pl-2"}>Units {title}</h4>
                        </FlexContainer>
                        <ActionIcon 
                            type={'add'}
                            onClick={() => handleAddQty(String(id))}
                        />
                </HeaderContainer>
            </ModalHeader>
            <ModalBody>
                <VirtualTable<Serial>
                    data={serials}
                    mapping={[{
                        name: 'Serial',
                        value: 'serial'
                    }, {
                        name: 'Batch',
                        value: 'batchId'
                    }, {
                        name: 'Asset Tag',
                        value: 'assetTag'
                    }, {
                        name: 'Holder',
                        value: 'email',
                        email: true
                    }, {
                        name: 'Status',
                        value: 'status'
                    }, {
                        name: 'Unit',
                        value: 'unit',
                        customWidth: 100
                    }]}
                    numRows={10}
                    handleClick={item => loadUnit(item.serial)}
                />
            </ModalBody>
        </CustomModal>
    );
}

const CustomModal = styled(Modal)`
    max-width: 1000px;
    width: 100%;
`;

const FlexContainer = styled.div`
    display: flex;
    align-items: center;
`;

const FlexBetween = styled(FlexContainer)`
    justify-content: space-between;
`;


